import {useContext} from 'react';
import {AuthenticationContext} from '../login/AuthenticationContext';

export const useOrganisation = () => {
  const {user} = useContext(AuthenticationContext);

  return user ? {
    id: user?.organisation_id,
  } : undefined;
};